import { IFRMParams } from "../Controls/FormParameters";
import { MessageWindow } from "../MessageWindow";
import { IWindowable } from "../UIManagerInterfaces";

export interface ISettingWindowFormBuilder {
    build(msgWindow: MessageWindow, parametricData: IFRMParams): Promise<IWindowable>;
}

export class ISettingWindowFormBuilder {
    private static _methods: (keyof ISettingWindowFormBuilder)[] = ["build"];

    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null && this._methods.every(value => typeof instance[value] === "function");
    }
}
